<template>
  <div class="shipped-order-mailing-list">
    <div class="title">
      <img src="../../../assets/img/personalCenter/order.png" alt="清单"/>
      <span>{{itemData.productName}}</span>
    </div>
    <div class="content" v-for="(item,index) in itemData.goodsListRespVOS" :key="index">
      <span>{{item.goodsName}}</span>
      <span><van-icon name="cross" />{{item.goodsQuantity}}</span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    itemData: {
      type: Object,
      default: () => {},
    },
  },
};
</script>

<style scoped lang="scss">
.shipped-order-mailing-list{
  margin-top: 22px;
  padding: 22px 29px;
  background: white;
  border-radius: 14px;

  .title{
    display: flex;
    align-items: center;
    font-size: 33px;
    line-height: 45px;

    span{
      flex: 1;
      overflow:hidden;
      white-space:nowrap;
      text-overflow:ellipsis;
    }

    img{
      width: 31px;
      height: 31px;
      margin-right: 13px;
    }
  }

  .content{
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 22px;
    font-size: 25px;
    line-height: 36px;

    span{
      display: block;
      &:first-child{
        width: 80%;
        overflow:hidden;
        color: #787878;
        white-space:nowrap;
        text-overflow:ellipsis;
      }
      &:last-child{
        display: flex;
        align-items: flex-end;
        color: #333;
        line-height: 30px;

        i{
          margin-bottom: 1px;
          transform: scale(0.7);
        }
      }
    }
  }
}
</style>
